// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/packaging-1/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produktePackaging1EN: PageEntry = {
  id: "example.en-produkte-packaging-1",
  locale: "en",
  slug: "produkte/packaging-1",
  seo: {
    title: "Packaging 1 | Dietz GmbH",
    description: "Packaging 1",
  },
  type: "post",
  h1: "Packaging 1",
  intro: "Packaging 1",
  blocks: [
    { kind: "image", src: "/images/live/verpackung-image001.png", alt: "Packaging 1", width: 600, height: 440 }
  ],
};
